module.exports = __webpack_public_path__ + "images/cf50dcb4.jpg";